module.exports = __webpack_public_path__ + "static/media/help-icon.ae4ca1be.svg";